import { FormControl, FormGroup } from '@angular/forms';
import { IEmployee } from '@internal-models/employee.model';
import { Action } from '@shared-libs/enums';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';
import { UserFormFactory } from './user-form.factory';

export class EmployeeFormFactory {
	public static createForUpdate(employee: IEmployee): IFormGroup<IEmployee> {
		return EmployeeFormFactory.create(Action.UPDATE, employee);
	}

	public static createForCreate(): IFormGroup<IEmployee> {
		const form = EmployeeFormFactory.create(Action.CREATE);
		form.addControl('User', UserFormFactory.create());
		return form;
	}

	public static createForRegisterTenant(): IFormGroup<IEmployee> {
		return new FormGroup({
			firstname: new FormControl(null, [SharedFormValidators.required, SharedFormValidators.strictString]),
			lastname: new FormControl(null, [SharedFormValidators.required, SharedFormValidators.strictString]),
			telephone: new FormControl(null, [SharedFormValidators.required, SharedFormValidators.phone]),
			email: new FormControl(null, [SharedFormValidators.required, SharedFormValidators.email]),
		}) as IFormGroup;
	}

	private static create(action: Action, employee?: IEmployee): IFormGroup<IEmployee> {
		return new FormGroup({
			id: new FormControl(employee?.id),
			firstname: new FormControl(employee?.firstname, [
				SharedFormValidators.required,
				SharedFormValidators.strictString,
			]),
			lastname: new FormControl(employee?.lastname, [
				SharedFormValidators.required,
				SharedFormValidators.strictString,
			]),
			telephone: new FormControl(employee?.telephone, [SharedFormValidators.phone]),
			email: new FormControl(employee?.email, [SharedFormValidators.required, SharedFormValidators.email]),
			jobRole: new FormControl(employee?.jobRole, [
				action === Action.UPDATE ? SharedFormValidators.required : () => null,
			]),
			receiveBeegoCommunication: new FormControl(
				action === Action.CREATE ? false : employee?.receiveBeegoCommunication
			),
			DigibankAgencyId: new FormControl(employee?.DigibankAgency?.id),
		}) as IFormGroup;
	}
}
